import { useDebounceCallback } from "@react-hook/debounce";
import { pipe } from "fp";
import React from "react";

import { type, creator, reducer, useDispatch } from "~/Action";
import { Input } from "~/Input";
import { useSelector } from "~/State";
import { Time } from "~/Time";

export type Search = string;

const delay = (): Time.Duration => Time.Duration.milliseconds(400);

export const matches = (text: string, search: Search): boolean =>
  text.toLocaleLowerCase().includes(search.toLocaleLowerCase());

export const useSearch = (): Search =>
  useSelector(({ drivers: { search } }) => search);

export const Component = () =>
  pipe(
    useDispatch(),
    (dispatch) =>
      useDebounceCallback(
        (event: React.ChangeEvent<HTMLInputElement>) =>
          dispatch(Action.Updated.create(event.target.value)),
        delay().duration
      ),
    () => (
      <Input
        style={{ width: 200 }}
        placeholder="Search drivers"
        onChange={(event) => event.persist()}
      />
    )
  );

export namespace State {
  export type State = Search;
  export const initial = (): State => "";
}

export namespace Action {
  export namespace Updated {
    export const { TYPE, create, reduce } = pipe(
      type("Drivers updated search" as const),
      creator((search: string) => ({ search })),
      reducer(
        ({ state, action: { search } }) => (state.drivers.search = search)
      )
    );
  }
}
